'use client'

import { type ReactNode, useEffect } from 'react'
import { cx } from 'utils/cx'

import text from 'fukku/styles/texts.module.scss'
import styles from './CommBanner.module.scss'

export interface CommBannerProps {
	id: string
	className?: string
	title?: ReactNode
	subtitle?: ReactNode
	links?: ReactNode[]
	onShow?: (id: string, ref?: React.RefObject<HTMLDivElement>) => void
	commRef?: React.RefObject<HTMLDivElement>
}

export function CommBanner(commBannerProps: CommBannerProps): React.ReactNode {
	const { id, title, className, links, onShow, subtitle, commRef } =
		commBannerProps
	const hasLinks = links && links.length > 0
	const isMultiLink = hasLinks && links.length > 1

	useEffect(() => {
		if (onShow) {
			onShow(id, commRef)
		}
	}, [onShow])

	return (
		<div
			className={cx(styles.banner, className)}
			id={id}
			data-testid={`commsBanner.${id}`}
			ref={commRef}
		>
			<div className={cx(text.uppercaseXL, styles.title)}>{title}</div>
			{subtitle && (
				<div className={cx(text.bodyM, styles.subtitle)}>{subtitle}</div>
			)}
			{hasLinks && (
				<ul
					className={cx(
						styles.links,
						isMultiLink
							? styles.multiLink
							: `${styles.monoLink} ${text.bodyMRegular}`
					)}
				>
					{links.map((link, index) => (
						<li
							className={cx(styles.link, text.bodyMRegularUnderline)}
							key={`link-${index.toString()}`}
						>
							{link}
						</li>
					))}
				</ul>
			)}
		</div>
	)
}
